import React, {
    createContext,
     useState,
     useMemo, 
   } from 'react';
   import PropTypes from 'prop-types';
   
   export const GlobalVarContext = createContext();
   
   const GlobalVarContextProvider = ({ children }) => {
     const [isLoggedIn, setIsLoggedIn] = useState(false);
     const [username, setUsername] = useState('');

     const [apiGlobal, setApiGlobal] = useState('https://navrang.mvd-tech.io/API/');
     const [apiGlobalforLogin, setApiGlobalforLogin] = useState('https://restaurant-bw.mvd-tech.io/API'); 
    // development
    //  const [apiGlobal, setApiGlobal] = useState('https://admin.bitevize.com/API/');
    //  const [apiGlobalforLogin, setApiGlobalforLogin] = useState('https://restaurant.bitevize.com/API'); 
    // // Production
   
     const value = useMemo(() => ({ 
       isLoggedIn, 
       setIsLoggedIn, 
       username, 
       setUsername,
       apiGlobal,
       apiGlobalforLogin,
     }), [isLoggedIn, username, apiGlobal, apiGlobalforLogin]);
   
     return (
       <GlobalVarContext.Provider value={value}>
         {children}
       </GlobalVarContext.Provider>
     );
   };
   
   GlobalVarContextProvider.propTypes = {
     children: PropTypes.node.isRequired,
   };

export default GlobalVarContextProvider; 
